import React, { createContext, useContext } from 'react';

const CopyToClipboardContext = createContext();

export const CopyToClipboardProvider = ({ children }) => {
    const initializeClipboard = (triggerId, targetId) => {
        const $triggerEl = document.getElementById(triggerId);
        const $targetEl = document.getElementById(targetId);

        if ($triggerEl && $targetEl) {
            const clipboard = new CopyClipboard(
                $triggerEl,
                $targetEl,
                { contentType: 'input', htmlEntities: false },
                { id: `${targetId}-copy`, override: true },
            );

            clipboard.copy();
        }
    };

    return <CopyToClipboardContext.Provider value={{ initializeClipboard }}>{children}</CopyToClipboardContext.Provider>;
};

export const useCopyToClipboardContext = () => {
    const context = useContext(CopyToClipboardContext);

    if (!context) {
        throw new Error('useCopyToClipboard must be used within a CopyToClipboardProvider');
    }

    return context;
};

export default useCopyToClipboardContext;
